import http from '@services/http';
import { Users } from './interfaces';

export const completePrivacyConsentRequest = (data: Users.CompletePrivacyConsentRequest.Request): Promise<Users.CompletePrivacyConsentRequest.Response> => {
  return http.patch(`/users/consent/privacy/${data.consentId}`, data);
};

export const findPrivacyConsentRequest = (): Promise<Users.FindPrivacyConsentRequest.Response> => {
  return http.get(`/users/consent/privacy`);
};